import { Button, Center, Paper, Stack, Text } from '@mantine/core';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { canGenerateWosIsiReport } from '@/module/WosIsiReport';

import { useRoleBoundary } from '@feature/security';

/**
 * Entry point to the WoS ISI report for the admin roles - they do not see the author section in
 * the sidebar, so the article / abstract lists are out of reach for them.
 */
export function WosIsiReportSection() {
  const { t } = useTranslation();
  const { isRoleOneOf } = useRoleBoundary();

  if (!isRoleOneOf(canGenerateWosIsiReport)) return null;

  return (
    <Paper
      component="section"
      aria-label={t('wosIsiReport.title')}
      flex={1}
      p="md"
      mih="200px"
    >
      <Stack gap="4px">
        <Text>{t('wosIsiReport.title')}</Text>
        <Text
          c="dimmed"
          size="sm"
          fs="italic"
        >
          {t('wosIsiReport.dashboardMeta')}
        </Text>
        <Center mt="20px">
          <Button
            component={Link}
            to="/author/wos-isi-report"
          >
            {t('wosIsiReport.analyticsButton')}
          </Button>
        </Center>
      </Stack>
    </Paper>
  );
}
